<template>
	<div class="overlay" @click="togglePopUp"></div>
	<div class="popUp">
    <div class="popUp__header">
      <h3>
        {{ parentObject.header }}
      </h3>
      <CrossIcon class="popUp__crossIcon" @click="togglePopUp"></CrossIcon>
    </div>
		<div class="popUp__content">
			<div class="scroll">
        <div class="imageList">
          <div v-for="(img, index) in minImages" :key="index" class="imageList__item">
            <img
                :key="index"
                :src="img"
                @click="show(index)"
                style="cursor: pointer;"
            />
          </div>
          <vue-easy-lightbox
              :visible="visible"
              :imgs="fullImages"
              :index="index"
              @hide="visible = false"
              :move-disabled="moveDisabled"
              :rotate-disabled=true
          />
        </div>
      </div>
		</div>
	</div>
</template>

<script>
import {mapActions} from "vuex";
import CrossIcon from '@/assets/sections/sectionGallery/CrossSvg.vue'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  components: {
    CrossIcon,
    VueEasyLightbox
  },
  props: {
    parentObject: Object,
	},
  data() {
    return {
      minImages: [],
      fullImages: [],
      visible: false,
      zoom: false,
      index: 0
    }
  },
  computed: {
    moveDisabled() {
      return !this.zoom;
    }
  },
  mounted() {
    this.initializeGallery()
    const handleDoubleClick = () => {
      this.zoom = !this.zoom;
      if(!this.zoom) {
        const resizeButton = document.querySelector('.toolbar-btn__resize')
        if (resizeButton) {
          resizeButton.click()
        }
      }
    }
    document.addEventListener('dblclick', handleDoubleClick);
  },
  methods: {
    ...mapActions(['getImageFromGalleryPath', 'getGalleryLength']),

    show(i) {
      this.index = i
      this.visible = true
      this.zoom = false;
    },

    async initializeGallery() {
      await this.getGalleryLengthFromStore()
      await this.loadImagePaths()
    },

    async getGalleryLengthFromStore() {
      const folder = this.parentObject.images.folder
      this.gallerylength = await this.getGalleryLength({ name: folder })
    },

    async loadImagePaths() {
      const folder = this.parentObject.images.folder
      for (let i = 0; i < this.gallerylength; i++) {
        const minPath = await this.getImageFromGalleryPath({
          name: folder,
          quality: 'min',
          index: i,
        });
        const fullPath = await this.getImageFromGalleryPath({
          name: folder,
          quality: 'full',
          index: i,
        })
        this.minImages.push(minPath)
        this.fullImages.push(fullPath)
      }
    },
    togglePopUp() {
      this.$store.commit('togglePopUpGallery')
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 7;
}

.popUp {
  display: flex;
  flex-direction: column;
	position: fixed;
  top: 5%;
	left: 5%;
  width: 90%;
  height: 90%;
	background-color: $primary-color-dark;
	border-radius: 50px;
	z-index: 7;

	&__header {
    position: sticky;
    top: 0;
    background: transparent;
    display: flex;
    justify-content: space-between;
    padding: 30px;
    h3 {
      @include h3;
    }
	}

  &__content {
    width: 100%;
    padding: 0 15px 0 30px;
    max-height: calc(90% - 50px);

    & .scroll {
      padding-right: 15px;
      max-height: 100%;
      overflow-y: auto;
      scrollbar-width: thin; /* Firefox */
      scrollbar-color: $primary-color-veryDark transparent; /* Firefox */

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: $primary-color-veryDark;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: $primary-color-bright;
      }
    }

    & .imageList {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      @media (max-width: 1023px) {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      }
      gap: 10px;

      &__item {
        background-color: #412F26;
        align-content: center;
        justify-content: center;
        border: 2px solid #412F26;
        border-radius: 10px;
        max-width: 400px;
        & img {
          display: block;
          border-radius: 10px;
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }
    }
  }

  &__crossIcon {
		cursor: pointer;
	}

	&__currentPhoto {
		height: 350px;
		width: 320px;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
			border-radius: 10px;
		}
	}

	.popUp__ul {
		@include flex(row, flex-start, flex-start);
		width: 100%;
		height: 100%;
		flex-wrap: wrap;
		overflow-y: auto;
		align-content: flex-start;

		.ul__icon {
			//flex: 0 0 calc(33.33% - 10px);
			height: 160px;
			width: 160px;
			margin: 10px 5px;

			img {
				max-width: 100%;
				max-height: 100%;
				object-fit: contain;
				border-radius: 10px;
			}
		}
	}
	.popUp__ul::-webkit-scrollbar {
		width: 4px;
	}

	.popUp__ul::-webkit-scrollbar-track {
		background: #333;
	}

	.popUp__ul::-webkit-scrollbar-thumb {
		background: #555;
		border-radius: 10px;
	}

	.popUp__ul::-webkit-scrollbar-thumb:hover {
		background: #888;
	}

	.popUp__ul::-webkit-scrollbar-button {
		background: #333;
		height: 0px;
	}
}

@media (max-width: 1023px) {
	.popUp__currentPhoto,
	.popUp__ul {
		@include center-margin;
		margin-top: 20px;
	}
}
</style>
